//
// Dark mode Favicon
// --------------------------------------------------
// Allows for switching between a light and dark mode favicon based on browser media preferences
// REQUIRES* specific markup setup, for examples search projects for the data-fav-src data attribute.
// REQUIRES* src/THEME/icons to be set up to have a _lightmode and _darkmode folder.

window.addEventListener('load', event => {

    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)');
    themeChange(prefersDarkMode);
    prefersDarkMode.addEventListener('change', themeChange);

    function themeChange(event) {
        const favSrcs = document.querySelectorAll('[data-fav-src]')

        for (let favSrc of favSrcs) {
            const ogSrc = favSrc.getAttribute('href');
            const darkModeSrc = ogSrc.replace('icons/_lightmode', 'icons/_darkmode');
            const lightModeSrc = ogSrc.replace('icons/_darkmode', 'icons/_lightmode');

            if (event.matches) {
                favSrc.setAttribute('href', darkModeSrc)
            } else {
                favSrc.setAttribute('href', lightModeSrc)
            }
        }
    }
});